<template lang="html">
    <div class="page" id="book">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2">
            <div v-if="player">
                <header>
                    <h2>{{ player.first_name }} {{ player.last_name }}</h2>
                    <ul class="links">
                        <li>
                            <router-link :to="{ name: 'proPlayers' }"
                                ><x-icon class="icon"
                            /></router-link>
                        </li>
                    </ul>
                </header>

                <h2 class="title">Next Lesson:</h2>

                <next-lesson
                    class="inverse"
                    :player="player"
                    :pro="true"
                    :lesson="player.next_lesson"
                    @lessonCancelled="cancelLesson"
                />

                <ul id="tasks" class="tasks2">
                    <li>
                        <router-link :to="{ name: 'proPlayerHistory' }">
                            <img src="@/assets/icons/player/calendar.svg" alt="" />
                            History:
                            <span
                                class="counter"
                                v-if="
                                    this.$store.state.user.incompleteLessonRecordsByPlayerId[
                                        player.id
                                    ]
                                "
                            >
                                {{
                                    this.$store.state.user.incompleteLessonRecordsByPlayerId[
                                        player.id
                                    ]
                                }}
                            </span>
                            <chevron-right-icon class="icon"></chevron-right-icon>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="{ name: 'proPlayerProfile' }">
                            <img src="@/assets/icons/player/cap.svg" alt="" />
                            Profile:
                            <chevron-right-icon class="icon"></chevron-right-icon>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="{ name: 'proPlayerMessages' }">
                            <img src="@/assets/icons/player/message.svg" alt="" />
                            Messages:
                            <chevron-right-icon class="icon"></chevron-right-icon>
                        </router-link>
                    </li>

                    <li style="background: white">
                        <router-link :to="{ name: 'proPlayerCredits' }">
                            <img src="@/assets/icons/player/credits.svg" alt="" />
                            Credits:
                            <chevron-right-icon class="icon"></chevron-right-icon>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="{ name: 'proPlayerSkills' }">
                            <img src="@/assets/icons/player/star.svg" alt="" />
                            Practice:
                            <chevron-right-icon class="icon"></chevron-right-icon>
                        </router-link>
                    </li>

                    <li style="background: #15f29f">
                        <router-link :to="{ name: 'proPlayerReminders' }">
                            <img src="@/assets/icons/player/ribbon.svg" alt="" />
                            Reminders:
                            <chevron-right-icon class="icon"></chevron-right-icon>
                        </router-link>
                    </li>
                </ul>

                <button
                    :disabled="busy"
                    @click.prevent="removePlayer"
                    class="button red removePlayer"
                    type="button"
                    name="button"
                >
                    Remove Player
                </button>
            </div>
            <!-- End Player -->

            <pre-loader v-else textColor="#267962" color="#267962" />
        </div>
    </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import preLoader from "@/components/App/Pre-loader";
import { ChevronRightIcon } from "vue-feather-icons";
import NextLesson from "@/components/Pro/Next-lesson";
import FadeImage from "@/components/App/fade-image";
export default {
    name: "player",
    components: { FadeImage, XIcon, preLoader, ChevronRightIcon, NextLesson },
    mounted() {
        if (!this.$store.state.activePlayer) {
            this.$store.dispatch("getPlayer", this.$route.params.id);
        }
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        cancelLesson($nextLesson) {
            this.$store.state.activePlayer.next_lesson = $nextLesson;
        },
        removePlayer() {
            this.$confirm(
                "Are you sure you want to remove this player? This will permanently delete all information about that player including lesson history and any bookings they might have.",
                () => {
                    this.busy = true;

                    window.axios
                        .delete("/user/" + this.$route.params.id)
                        .then(() => {
                            this.$notify({
                                text: "Player removed",
                            });
                            this.busy = false;
                            this.$router.push({ name: "proHome" });
                        })
                        .catch(() => {
                            this.busy = false;
                        });
                },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.counter {
    display: block;
    position: absolute;
    background: #fff;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    top: -10px;
    font-size: 14px;
    right: 14px;
    color: $green_0;
    line-height: 24px;
    text-align: center;
}
.removePlayer {
    margin-top: 20px;
}
.title {
    font-size: 16px;
    margin-bottom: 10px;
}
.tasks2 li img {
    top: 17px !important;
}
.tasks2 li .icon {
    top: 46px;
    bottom: auto;
}
</style>
